module.exports = {"satisfaction":{"label":"The expressed satisfaction is perceived by","label_short":"Perceived by","own":"The assessed person himself/herself","answerer":"The answering person"}}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/satisfactionperceptions.json
// module id = PyMs
// module chunks = 18